module.exports = __webpack_public_path__ + "static/media/cq_documenti b.26019df7.svg";